import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import { MedicalModalType } from "@/schema/renewal-page/page-content.schema";

type ModalContentProps = {
  onClick?: () => void;
  onClickSecondary?: () => void;
  isSecondaryCtaEnabled?: boolean;
  id: string;
} & MedicalModalType;

export function ModalContent({
  medicalModalTitle,
  medicalModalContent,
  medicalModalCtaLabel,
  medicalModalSecondaryCtaLabel,
  isSecondaryCtaEnabled,
  contactNumber,
  onClick,
  onClickSecondary,
  id,
}: Readonly<ModalContentProps>) {
  return (
    <div className="flex flex-col gap-spacing-l">
      <div className="flex flex-col gap-spacing-xs md:gap-spacing-s">
        <h1 className="font-header-font text-m leading-custom-size-compact md:text-3xl  md:leading-[34px] text-left text-text-title pr-spacing-l md:pr-0">
          {medicalModalTitle}
        </h1>
        <div className="text-text-body text-xs text-left leading-27">
          <RichText
            richText={medicalModalContent}
            className="flex flex-col gap-spacing-xs [&>ul]:list-disc [&>ul>li]:marker:text-4xs [&>ul]:ml-[27px] [&>ul>li]:pb-spacing-xs [&>ul>li:last-child]:pb-0 "
          />
        </div>
      </div>
      <div className="flex flex-col justify-center min-w-[279px] md:min-w-[304px] md:gap-spacing-l gap-spacing-xs">
        {id === "dont-meet-conditions" ? (
          <a
            tabIndex={-1}
            href={`${contactNumber}`}
            className="callus__tel_no w-[100%]"
          >
            <LabelButtonWrapper
              id={`${id}-modal-primary-button`}
              data-testid={`${id}-modal-primary-button`}
              hierarchy="primary"
              label={medicalModalCtaLabel ?? "Call us"}
              onClick={onClick}
              className="text-text-functional !h-[48px] w-[100%] font-semibold leading-[18px]"
            />
          </a>
        ) : (
          <LabelButtonWrapper
            id={`${id}-modal-primary-button`}
            data-testid={`${id}-modal-primary-button`}
            hierarchy="primary"
            label={medicalModalCtaLabel ?? "Ok, I understand"}
            onClick={onClick}
            className="text-text-functional !h-[48px] w-[100%] font-semibold leading-[18px]"
          />
        )}
        {isSecondaryCtaEnabled && (
          <LabelButtonWrapper
            data-testid={`${id}-modal-secondary-button`}
            id={`${id}-modal-secondary-button`}
            label={medicalModalSecondaryCtaLabel ?? ""}
            onClick={onClickSecondary}
            className="underline underline-offset-[2px] text-xs text-interactive-secondary-default font-semibold leading-[18px] focus:outline-none focus:ring-0  "
          />
        )}
      </div>
    </div>
  );
}
